import IGiaoDucCourseAPI from '@/apis/business/MISAStore/igiaoduc-course-api.js'
import PracticeCourseAPI from '@/apis/business/student/practice-course-api.js'

export default {

  namespaced: true,

  state: {
    listIGiaoDucCourses: [], // Danh sách học liệu của I Giáo dục
    totalExerciseGIAODUC: 0, // Số lượng học liệu của I Giáo dục
    iGiaoDucCourses: [], // Danh sách filter theo điều kiện
    iGiaoDucCourse: {},
    iGiaoDucCourseDetails: []
  },

  getters: {},

  mutations: {
    setListCourses (state, listCourseStorage) {
      state.listIGiaoDucCourses = listCourseStorage
    },

    /**
     * set total count Course
     * CreateBy: VHSON 23.09
     */
    setTotalCount (state, totalExerciseGIAODUC) {
      state.totalExerciseGIAODUC = totalExerciseGIAODUC
    },

    /**
     * set list Course
     * CreateBy: VHSON 23.09
     */

    setIGiaoDucCourse (state, iGiaoDucCourses) {
      state.iGiaoDucCourses = iGiaoDucCourses
    },

    /**
     * set IGiaoDucCourse
     * @param {*} state
     * @param {*} iGiaoDucCourse
     */
    setIGiaoDuc (state, iGiaoDucCourse) {
      state.iGiaoDucCourse = iGiaoDucCourse
    },

    setIGiaoDucCourseDetail (state, iGiaoDucCourseDetails) {
      state.iGiaoDucCourseDetails = iGiaoDucCourseDetails
    },

    /**
     * xét dữ liệu IGiaoDuc
     * @param {any} state
     * @param {any} courseID
     */
    setPracticeCourseByID (state, courseID) {
      state.courseID = courseID
      state.iGiaoDucCourse.IsBuy = true
    }

  },

  actions: {

    /**
     * Lấy học liệu theo id
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getByIdIGiaoDucCourse (context, params) {
      return new Promise((resolve, reject) => {
        IGiaoDucCourseAPI.getAsync(`${params}`)
          .then((res) => {
            context.commit('setIGiaoDuc', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học liệu liên quan theo điều kiện id và gradeID
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getFilterByGiaoDucCourse (context, params) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync(`id/${params.id}?source=${params.source}&sourceType=${params.sourceType}`)
          .then((res) => {
            if (res.Data) {
              context.commit('setIGiaoDucCourse', res.Data.ListIGiaoDucCourse)
              context.commit('setIGiaoDuc', res.Data.PracticeCourse)
              context.commit('setIGiaoDucCourseDetail', res.Data.ListIGiaoDucCourseDetail)
              resolve(res.Data)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Chức năng sử dụng ngay : thêm vào bảng PracticeCourse
     * @param {any} context
     * @param {any} params
     * CreateBy: Nvduc 10.05
     */
    postPracticeCourse (context, params) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.postAsync('courseParam', params)
          .then((res) => {
            context.commit('setPracticeCourseByID', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học liệu của I Giáo dục
     * @author VHSon
     * @param {*} textSearch
     * @param {*} gradeID
     * @param {*} subjectID
     * @param {*} sourceType
     * @returns
     */
    getlistIGiaoDucCourse (context, courseParams) {
      return new Promise((resolve, reject) => {
        IGiaoDucCourseAPI.getAsync(
        `/giaoduc-courses?textSearch=${courseParams.textSearch}` +
          `&gradeID=${courseParams.gradeID}` +
          `&subjectID=${courseParams.subjectID}` +
          `&takeCharge=${courseParams.takeCharge}` +
          `&pageIndex=${courseParams.pageIndex}` +
          `&pageSize=${courseParams.pageSize}`
        )
          .then((res) => {
            context.commit('setListCourses', res?.Data)
            context.commit('setTotalCount', res.Data?.Total)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
